import React, { useState, useEffect } from 'react';
import { withStyles } from '@mui/styles';
import { WithStyles, StyleRules, ClassNameMap } from '@mui/material/styles/withStyles';
import { Theme } from '@mui/material/styles';
import { Tooltip, TextField,  Grid, Typography} from "@mui/material";
import * as request from 'superagent';
import SendIcon from '@mui/icons-material/Send';
import VerifiedUser from '@mui/icons-material/VerifiedUser';
import LoadingButton from '@mui/lab/LoadingButton';
import ErrorView from '~common/components/error-view';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: "100%"
  },
  textField: {
    width: "100%"
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
  match: any;
}


const MFAEmailSetup: React.FC<Props & WithStyles<keyof typeof styles>> = (props) => {
  const { classes }: { classes: ClassNameMap } = props;

  const [error, setError] = useState(null);
  const [token, setToken] = useState(undefined);
  const [tokenSent, setTokenSent] = useState(false)
  const [tokenSending, setTokenSending] = useState(false)
  const [tokenVerifying, setTokenVerifying] = useState(false)
  const [invalidToken, setInvalidToken] = useState(undefined);

  const handleAPIError = (err: any) => {
    setError(err);
  };

  const onErrorClose = () => {
    setError(undefined);
  }

  const sendOTPEmail = () => {
    setTokenSending(true)
    request.put("/api/auth/users/send-otp-email").send({userName: props.userName}).then(()=>{
      setTokenSending(false)  
      setTokenSent(true)
    }).catch((err)=>{
      setTokenSending(false)  
      handleAPIError(err);
    })
  }

  const handleTokenChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    setInvalidToken(false);
    setToken(evt.target.value);
  };

  const verifyOTP = () => {
    setTokenVerifying(true)
    request.put(`/api/auth/users/verify-otp-enroll/Email`)
      .send({token: token, userName: props.userName, redirectToLogin: props.redirectToLogin})
      .then((response: request.Response) => {
        setTokenVerifying(false)
        if (!response.body.success) {
          setInvalidToken(true);
        } else {
            if (props.onSetupSuccess) {
                props.onSetupSuccess()
            } else {
                window.location.href = "/";
            }
        }
      })
      .catch((err) => {
        setTokenVerifying(false)
        handleAPIError(err);
      });
  };

  var errorView
  if (error) {
    errorView = <ErrorView error={error} classes={{}} onClose={onErrorClose} />
  }

  return (
    <div>
        {errorView}
        <Grid container spacing={8}>
            <Grid item className={classes.gridItem} xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography style={{ marginBottom: 10 }} variant="h6">
                    Verify email
                </Typography>
                <Typography style={{ marginBottom: 10 }} variant="body2">
                    An authentication code will be sent to your email
                </Typography>
                <Tooltip title={tokenSent ? "Send new code?" : undefined}>
                  <LoadingButton
                      loading={tokenSending}
                      loadingPosition="end"
                      variant="contained"
                      color={tokenSent ? "success" : "primary"}
                      endIcon={<SendIcon />}
                      className={classes.button}
                      onClick={sendOTPEmail}
                  >
                      {tokenSent ? "Code Sent" : "Send Code"}
                  </LoadingButton>
                </Tooltip>
                
            </Grid>
            <Grid item className={classes.gridItem} xs={12} sm={6} md={3} lg={3} xl={3}>
                <TextField
                    error={invalidToken}
                    name="token"
                    label="One Time Code"
                    variant="standard"
                    className={classes.textField}
                    value={token || ''}
                    helperText={invalidToken ? "Invalid Code" : "Provide the code from the email"}
                    onChange={handleTokenChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                />
            </Grid>
            <Grid item className={classes.gridItem} xs={4} sm={4} md={4} lg={4} xl={4}>
                <LoadingButton
                    loading={tokenVerifying}
                    loadingPosition="end"
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    endIcon={<VerifiedUser />}
                    onClick={verifyOTP}
                >
                    Verify
                </LoadingButton>
            </Grid>
        </Grid>
    </div>
  )
};

export default withStyles(styles)(MFAEmailSetup);